import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精心策划的主题内容合集，发现不一样的追剧视角
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <div
              key={item.id}
              className={`group relative rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all duration-300 hover:-translate-y-1 ${
                item.id <= 2 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`${item.id <= 2 ? 'aspect-[2/1]' : 'aspect-[4/3]'} overflow-hidden bg-background-200`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block text-xs font-medium text-accent-500 bg-accent-500/10 px-2 py-0.5 rounded mb-2 whitespace-nowrap">
                  {item.subtitle}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-foreground-950 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}